import { inject } from '@angular/core';

import { AppInfoService } from '@app/core/services/app-info.service';
import { AppService } from '@app/core/services/app.service';

export const provideAppInit = () => {
  const appService = inject(AppService);
  return appService.init();
};

export const provideApiInit = () => {
  const appInfoService = inject(AppInfoService);
  return appInfoService.appInfo.apiEnvironment;
};
